import services from '.'
import { IData } from '../@types'
import { INewPayment, Payment } from '../@types/payment'
import { getAxiosErrorMessage } from '../resources'

const baseURL = '/payments'

async function pay({ amount, phoneNumber }: INewPayment): Promise<void> {
  try {
    await services.api
      .post<IData<void>>(baseURL, { amount, phoneNumber })
      .then(({ data }) => data?.data)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getAll(): Promise<Payment[] | undefined> {
  try {
    const data = await services.api
      .get<IData<Payment[]>>(`${baseURL}/log`)
      .then(({ data }) => data?.data)
    return data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getAllByDates(
  startDate?: string,
  endDate?: string,
): Promise<Payment[] | undefined> {
  try {
    console.log({ startDate, endDate })
    const { data } = await services.api.get<IData<Payment[]>>(
      `${baseURL}/log?startDate=${startDate}&endDate=${endDate}`,
    )

    return data.data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getByDate(date: Date): Promise<Payment[] | undefined> {
  try {
    const { data } = await services.api.get<IData<Payment[]>>(
      `${baseURL}/log?date=${date.toISOString()}`,
    )
    return data.data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default { pay, getAll, getByDate, getAllByDates }
